import confirm from "./confirm.js";

Alpine.directive('confirm', confirm);
